import { render, staticRenderFns } from "./PricingTable.vue?vue&type=template&id=70142910&scoped=true&lang=pug&"
import script from "./PricingTable.vue?vue&type=script&lang=ts&"
export * from "./PricingTable.vue?vue&type=script&lang=ts&"
import style0 from "./PricingTable.vue?vue&type=style&index=0&id=70142910&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70142910",
  null
  
)

export default component.exports